import styled from 'styled-components';
import { Input } from 'antd';

interface ButtonWrapperProps {
	$selected?: boolean;
}

const COLOR_BORDER = '#E9E9E9';
const COLOR_DEFAULT = '#FFFFFF';
const COLOR_SELECTED = '#2F54EB';

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
	width: 100%;
	font-size: 1rem;
	box-shadow: none;
	padding: 0.5rem 0;
	border-radius: 7px;
	color: ${({ $selected }) => ($selected ? COLOR_DEFAULT : '#262626E5')};
	border: ${({ $selected }) => ($selected ? 'none' : `2px solid ${COLOR_BORDER}}`)};
	background-color: ${({ $selected }) => ($selected ? COLOR_SELECTED : COLOR_DEFAULT)};

	&:hover {
		opacity: 0.8;
		cursor: pointer;
		transition: all 1s;
	}
`;

export const InputWrapper = styled(Input)`
	height: 100%;
	border-radius: 7px;
	border: 1px solid ${COLOR_BORDER};

	.ant-input-prefix {
		margin-right: 0.7rem;
	}
`;
